import { useEffect, useRef, useState } from 'react';
import Card from '../../ui/Card/Card';
import Icon from '../../ui/Icon/Icon';
import styles from './CodexCard.module.css';

export default function CodexCard({ codex, onOpen, onPatch }) {
  const [editing, setEditing] = useState(false);
  const [title, setTitle] = useState(codex.title || '');
  const inputRef = useRef(null);

  // Keep in sync with external updates (optimistic/realtime).
  useEffect(() => {
    setTitle(codex.title || '');
  }, [codex.title]);

  useEffect(() => {
    if (editing) inputRef.current?.focus();
  }, [editing]);

  const initial = (codex.title || '?').charAt(0).toUpperCase();

  const save = async () => {
    setEditing(false);
    const next = title.trim();
    if (!next || next === codex.title) {
      setTitle(codex.title || '');
      return;
    }
    try {
      await onPatch(codex.id, { title: next });
    } catch {
      setTitle(codex.title || '');
    }
  };

  return (
    <Card as="div" interactive onClick={() => !editing && onOpen(codex.id)}>
      <div className={styles.cover}>{initial}</div>
      <div className={styles.body}>
        {editing ? (
          <input
            ref={inputRef}
            type="text"
            className={styles.titleInput}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            onBlur={save}
            onKeyDown={(e) => {
              if (e.key === 'Enter') e.target.blur();
              if (e.key === 'Escape') {
                setTitle(codex.title || '');
                setEditing(false);
              }
            }}
            onClick={(e) => e.stopPropagation()}
          />
        ) : (
          <div className={styles.titleRow}>
            <span className={styles.title}>{codex.title}</span>
            <span
              role="button"
              tabIndex={0}
              className={styles.pencil}
              title="Rename codex"
              onClick={(e) => {
                e.stopPropagation();
                setEditing(true);
              }}
            >
              <Icon name="Pencil" size={14} />
            </span>
          </div>
        )}
        <span className={styles.meta}>
          {codex.type === 'screenplay' ? 'Screenplay' : 'Codex'}
        </span>
      </div>
    </Card>
  );
}
